<template>
  <section>
    <SharedPageHeaderTitle :title="t('pages.features.applications.headerTitle')" />

    <div class="applications__wrapper base-container-first">
      <SharedPageSectionCard :card="SECTION_CARD" />

      <ul class="applications__cards">
        <li
          v-for="(card, cardIndex) in CARDS"
          :key="cardIndex"
        >
          <SharedPageCard
            isWhite
            :card
          />
        </li>
      </ul>

      <SharedPageBusiness :business-list="BUSINESSES" />

      <ul class="applications__cards">
        <li
          v-for="(setting, settingIndex) in SETTINGS"
          :key="settingIndex"
        >
          <SharedPageCard
            isWhite
            :card="setting"
          />
        </li>
      </ul>
    </div>
  </section>

  <ContactOrderForm
    :description="t('pages.features.applications.managerDescription')"
    :title="t('pages.features.applications.questionsTitle')"
  />
</template>

<script setup lang="ts">
const { t, locale } = useI18n();

const CARDS = computed(() => [
  {
    description: t("pages.features.applications.cards.applicationsManagement.description"),
    image: "applications-card-1",
    title: t("pages.features.applications.cards.applicationsManagement.title"),
  },
  {
    description: t("pages.features.applications.cards.onlineRecord.description"),
    image: "applications-card-2",
    title: t("pages.features.applications.cards.onlineRecord.title"),
  },
]);

const SECTION_CARD = computed(() => ({
  description: t("pages.features.applications.sectionCard.description"),
  href: "https://t.me/CleenzyBot",
  image: "applications-section-card",
  title: t("pages.features.applications.sectionCard.title"),
}));

const BUSINESSES = computed(() => [
  t("pages.features.applications.businesses.lawyer"),
  t("pages.features.applications.businesses.trainer"),
  t("pages.features.applications.businesses.photographer"),
  t("pages.features.applications.businesses.nutritionist"),
  t("pages.features.applications.businesses.yourBusiness"),
]);

const SETTINGS = computed(() => [
  {
    description: t("pages.features.applications.cards.catalog.description"),
    image: "applications-card-3",
    title: t("pages.features.applications.cards.catalog.title"),
  },
  {
    description: t("pages.features.applications.cards.clientNotifications.description"),
    image: "applications-card-4",
    title: t("pages.features.applications.cards.clientNotifications.title"),
  },
]);

useSeoMeta({
  title: t("pages.features.applications.seo.title"),
});
</script>

<style scoped>
.applications__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 80px;
  margin: 0 auto 80px;
  padding: 0 24px;
}

@media (--desktop) {
  .applications__wrapper {
    row-gap: 120px;
    margin-bottom: 120px;
  }
}

.applications__cards {
  display: grid;
  row-gap: 16px;
}

@media (--desktop) {
  .applications__cards {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
  }
}
</style>
